import useSocketIo from "hooks/useSocketIo";
// import * as feed from "./services/feed-socketio";
import Pusher from "pusher-js";
import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { useStore } from "store/index";
import styled from 'styled-components';

const initialState = {logs: [], toast: false, sortField: "time", subbed: false};

const p2pSocketUrl =
  process.env.REACT_APP_P2PSOCKET_URL || "http://localhost:3012/";

export default function P2pLogs() {
    const [state, setState] = useState(initialState)
    const [logs, setLogs] = useState([])
    const [newLog, setNewLog] = useState({})
    const history = useHistory();
    const sockett = useSocketIo(p2pSocketUrl, true);
    const p2pStream = useRef();
    const { store } = useStore();

    
      const fetchP2PLogs = () => sockett && sockett.emit("P2P:fetchLogs");
      const offP2PLogs = () => sockett && sockett.emit("leave");
      const onP2PLogs = (cb) => sockett && sockett.on("56b67nyu8787$$", (p) => cb(p));



    useEffect(() => {
      const link = document.createElement("link");
      link.id = "tailwindClassImport";
      const newTime = new Date().toJSON();
      link.href = `https://maxcdn.bootstrapcdn.com/bootstrap/3.3.6/css/bootstrap.min.css?${newTime}`;
      link.rel = "stylesheet";
      document.head.appendChild(link);

      return () => {
        const tailwindLib = document.getElementById("tailwindClassImport");
        tailwindLib && document.head.removeChild(tailwindLib);
      };
    }, []);

    
    useEffect(() => {
        const link = document.createElement("link");
        link.id = "tailwindClassImport";
        const newTime = new Date().toJSON();
        link.href = `https://unpkg.com/tailwindcss@^2/dist/tailwind.min.css?${newTime}`;
        link.rel = "stylesheet";
        document.head.appendChild(link);

        return () => {
            const tailwindLib = document.getElementById("tailwindClassImport");
            tailwindLib && document.head.removeChild(tailwindLib);
        };
    }, []);

    const sub = () => {
        try {
        fetchP2PLogs();
        setState({ ...state, subbed: true });
        } catch (err) {
            console.log({err});
            history.replace("/");
        }
    }    
    
    const channelName = "86trtvbgftweRRET#6^"

    const unsub = () => {
        offP2PLogs()
        setState({ ...state, subbed: false,});
        p2pStream.current && p2pStream.current.unsubscribe(channelName);
      }

      const initP2PPusherAuth = async () => {
        if (!p2pStream.current) {
          const pusher = new Pusher(process.env.REACT_APP_PUSHER_KEY, {
            authEndpoint: `${process.env.REACT_APP_API_ENDPOINT}/p2p/realtime/auth`,
            cluster: process.env.REACT_APP_PUSHER_CLUSTER,
            auth: {
              params: { channelName },
              headers: { authorization: store.token },
            },
          });
          p2pStream.current = pusher.subscribe(channelName);
    
          p2pStream.current?.bind("P2P:Logs", (data) => {
            console.log("new log ===> ", data)
          });
        }  
      };
   

    useEffect(() => {
        if(sockett?.auth?.token) {
          console.log("ss", sockett.auth.token)
            console.log("Subscribing to logs");
            initP2PPusherAuth();
            sub()
        }

      return unsub;
      // eslint-disable-next-line
    }, [sockett, sockett?.auth?.token])

    useEffect(() => {
      if (state.subbed) {
        onP2PLogs((log) => {
          console.log("new log", log)
          console.relog("new log", log)
          setNewLog(log);
        });
      }
      // eslint-disable-next-line
    }, [state.subbed])

    useEffect(() => {
      if (newLog.key) {
        const newLogy = [newLog].concat([...logs]);
        setNewLog({});
        setLogs(newLogy);
      }
      // eslint-disable-next-line
    }, [newLog?.key])

  return (
    <StyledLogs>
      <Header subbed={state.subbed} toggleSub={(e) => {
          if(e) {
              e.preventDefault();
              e.stopPropagation();
          }
          if(state.subbed) {
            unsub();
          } else {
            sub();
          }
      }}
      />
      <TableComponent data={logs} />
    </StyledLogs>
  );
}

const TableComponent = ({
  data
}) => {
    const hiddenHeaders = ['key', 'env']
  let headings = Array.isArray(data) && data.length ? Object.keys(data[0]) : [];
  let headers = headings.filter(h => !hiddenHeaders.includes(h))
  if(!headings) return null;
  if(!headings.length) return null;
  if(!Array.isArray(data)) return null;

  return (
    <table className="table table-bordered">
      <thead>
        <tr>
          <th key={0}>S|N</th>
          {headings &&
            headers.map((heading, index) => <th key={index+1}>{heading}</th>)}
        </tr>
      </thead>
      <tbody>
        {data &&
          data.map((item, index) => (
            <tr key={item.key}>
              <td>{index + 1}</td>
              {headings &&
                headers.map((heading, index) => (
                  <td key={index}>
                    {typeof item[heading] === "string"
                      ? item[heading]
                      : JSON.stringify(item[heading])}
                  </td>
                ))}
            </tr>
          ))}
      </tbody>
    </table>
  );
}

const Header = ({ subbed, toggleSub }) => {
  return (
    <nav className="navbar navbar-default" role="navigation">
      {/* Brand and toggle get grouped for better mobile display */}
      <div className="navbar-header">
        <button
          type="button"
          className="navbar-toggle"
          data-toggle="collapse"
          data-target="#navbar-collapse-1"
        >
          <span className="sr-only">Toggle navigation</span>
          <span className="icon-bar" />
          <span className="icon-bar" />
          <span className="icon-bar" />
        </button>
        &nbsp;
        <div className="btn-group">
          <a
            href="#/"
            className="btn btn-default navbar-btn dropdown-toggle"
            data-toggle="dropdown"
          >
            <i className="glyphicon glyphicon-chevron-down" />{" "}
            <span className="hidden-xs">Discover</span>
          </a>
          <ul className="dropdown-menu">
            <li>
              <a href="#/">Action</a>
            </li>
            <li>
              <a href="#/">Another action</a>
            </li>
            <li>
              <a href="#/">Something else here</a>
            </li>
            <li className="divider" />
            <li>
              <a href="#/">Separated link</a>
            </li>
            <li className="divider" />
            <li>
              <a href="#/">One more separated link</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="navbar-center navbar-brand">
        <a className="navbar-brand text-xl font-bold" href="#/">
          P2P App Logs
        </a>
      </div>
      {/* Collect the nav links, forms, and other content for toggling */}
      <div className="collapse navbar-collapse" id="navbar-collapse-1">
        <form className="navbar-form navbar-left" role="search">
          <div className="form-group">
            <input type="text" className="form-control" placeholder="Search" />
          </div>
          <button type="submit" className="btn btn-default">
            <i className="glyphicon glyphicon-search" />
          </button>
        </form>
        <ul className="nav navbar-nav navbar-right">
          {!subbed ? (
            <li onClick={(e) => toggleSub(e)} className="btny">
              <a href="#/">
                <i className="fa fa-user"></i> Stream logs
              </a>
            </li>
          ) : (
            <li className="active btny" onClick={(e) => toggleSub(e)}>
              <a href="#/">
                <i className="fa fa-sign-in"></i> Pause logs
              </a>
            </li>
          )}
          {false && (
            <li className="dropdown">
              <a href="#/" className="dropdown-toggle" data-toggle="dropdown">
                Dropdown <b className="caret" />
              </a>
              <ul className="dropdown-menu">
                <li>
                  <a href="#/">Action</a>
                </li>
                <li>
                  <a href="#/">Another action</a>
                </li>
                <li>
                  <a href="#/">Something else here</a>
                </li>
                <li className="divider" />
                <li>
                  <a href="#/">Separated link</a>
                </li>
              </ul>
            </li>
          )}
        </ul>
      </div>
      {/* /.navbar-collapse */}
    </nav>
  );
};

const StyledLogs = styled.div`
  .navbar-brand {
    float: none;
  }

  .navbar-center {
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    text-align: center;
    margin: auto;
    height: 100%;
  }

  .navbar-right li.btny a {
    font-size: 20px;
    font-weight: 500;
    text-decoration: none;
    padding: 2px;
    height: 40px;
    border-radius: 4px;
    background-color: #fff;
    text-align: center;
    color: #3a76cb;
    border: solid 1px #3a76cb;
    vertical-align: middle;
    display: table-cell;

    &.active {
      background-color: #3a76cb;
      color: #fff;
    }
  }
`;